export enum Sort {
  Ascending = "asc",
  Descending = "desc",
}
